import { useEffect, useState } from 'react'

import { Box, Spinner, Text } from '@fairfashion/design-system'

import { DeclarationTable } from '../../../../components/DeclarationTable/declaration-table.comp'
import { IDeclaration } from '../../../../sdk/declaration/finished-item-profile.types'
import { sdk } from '../../../../services/sdk'

import * as Styles from './provider-declarations.styles'
import { ProviderDeclarationsProps } from './provider-declarations.types'

export const ProviderDeclarations = ({
  companyTaxId,
}: ProviderDeclarationsProps) => {
  const [declarations, setDeclarations] = useState<IDeclaration[]>([])
  const [isLoading, setIsLoading] = useState(false)

  const fetchDeclarations = async () => {
    try {
      setIsLoading(true)
      const declarations = await sdk.declaration.getDeclarations(companyTaxId)
      setDeclarations(declarations)
    } catch (error) {
      console.error(error)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    fetchDeclarations()
  }, [companyTaxId])

  if (isLoading) {
    return (
      <Box
        width="100%"
        direction="column"
        alignItems="center"
        justifyContent="center"
        minHeight="300px"
      >
        <Spinner size="32px" />
      </Box>
    )
  }

  const isLastDeclaration = (index: number) => {
    return index === 0
  }

  return (
    <Box width="100%" direction="column">
      {declarations && declarations?.length > 0 ? (
        <Box width="100%" direction="column">
          {declarations
            ?.slice()
            .sort((a, b) => {
              const dateA = a.from ? new Date(a.from).getTime() : 0
              const dateB = b.from ? new Date(b.from).getTime() : 0
              return dateB - dateA
            })
            .map((declaration, index) => (
              <Box width="100%" alignItems="stretch" key={index}>
                <Box flex={1} direction="column" alignItems="center">
                  <Styles.Circle active={isLastDeclaration(index)} />
                  <Styles.Line />
                </Box>
                <Box width="100%" paddingX={2} direction="column">
                  <Box width="100%" gap={2} alignItems="center">
                    <Text color={isLastDeclaration(index) ? 'grey_1' : 'error'}>
                      <Styles.Title
                        color={isLastDeclaration(index) ? 'grey_1' : 'error'}
                      >
                        {new Date(declaration.from).toLocaleDateString()}
                      </Styles.Title>{' '}
                      até{' '}
                      <Styles.Title
                        color={isLastDeclaration(index) ? 'grey_1' : 'error'}
                      >
                        {new Date(declaration.to).toLocaleDateString()}
                      </Styles.Title>
                    </Text>
                  </Box>
                  <Box
                    width="700px"
                    maxWidth="100%"
                    direction="column"
                    paddingY={1}
                    marginBottom={2}
                  >
                    <Text color={isLastDeclaration(index) ? 'grey_1' : 'error'}>
                      {isLastDeclaration(index)
                        ? 'Última declaração'
                        : 'Declaração expirada'}
                    </Text>

                    <Box marginTop={3} width="100%">
                      <DeclarationTable
                        declaration={declaration}
                        size="small"
                      />
                    </Box>
                  </Box>
                </Box>
              </Box>
            ))}
        </Box>
      ) : (
        <Box
          alignItems="center"
          justifyContent="center"
          width="100%"
          padding={6}
        >
          <Text align="center">Nenhuma declaração encontrada</Text>
        </Box>
      )}
    </Box>
  )
}
